import photo1 from '../../logos/photo1.jpeg'
import photo2 from '../../logos/photo2.jpeg'
import photo3 from '../../logos/photo3.jpeg'

import fphoto1 from '../../logos/fphoto1.jpeg'
import fphoto2 from '../../logos/fphoto2.jpeg'
import fphoto3 from '../../logos/fphoto3.jpeg'

import bphoto1 from '../../logos/bphoto1.jpeg'


export const MobileApp = [
    {
        photo: photo1,
        id: 1,
    },
    {
        photo: photo2,
        id: 2,
    },
    {
        photo: photo3,
        id: 3,
    }
]
export const frontend = [
    {
        photo: fphoto1,
        id: 1,
    },
    {
        photo: fphoto2,
        id: 2,
    },
    {
        photo: fphoto3,
        id: 3,
    }
]
export const backend = [
    {
        photo: bphoto1,
        id: 1,
    },
    {
        photo: bphoto1,
        id: 2,
    },
    {
        photo: bphoto1,
        id: 3,
    }
]